import { render, staticRenderFns } from "./EditTree.vue?vue&type=template&id=5905dfe6&scoped=true&"
import script from "./EditTree.vue?vue&type=script&lang=js&"
export * from "./EditTree.vue?vue&type=script&lang=js&"
import style0 from "./EditTree.vue?vue&type=style&index=0&id=5905dfe6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5905dfe6",
  null
  
)

export default component.exports